import { render, staticRenderFns } from "./docPreview.vue?vue&type=template&id=f62dc50e&scoped=true"
import script from "./docPreview.vue?vue&type=script&lang=js"
export * from "./docPreview.vue?vue&type=script&lang=js"
import style0 from "./docPreview.vue?vue&type=style&index=0&id=f62dc50e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62dc50e",
  null
  
)

export default component.exports